import {GetterTree} from 'vuex'
import {PersonaMasterState} from '@/store/modules/area/master/persona/type'
import {RootState} from '@/store/types'

export const getters: GetterTree<PersonaMasterState, RootState> = {}
